/** @format */

/* eslint require-await: "warn" -- Legacy code: do not use as an example. */
import { AxiosResponse } from 'axios';

import { SubmissionErrorCode } from '@toucan/common/services/application/constants';

import { client } from '@toucan/client/global/axios';

export async function getCsrfToken() {
    return client.get('/_csrf');
}

export async function getCsrfTokenValue() {
    const response = await getCsrfToken();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return -- Legacy code: do not use as an example.
    return response?.data?.csrfToken ?? '';
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- Legacy code: do not use as an example.
export const isInvalidCSRFResponse = (response: any): boolean =>
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- Legacy code: do not use as an example.
    response?.data?.code === SubmissionErrorCode.INVALID_CSRF;

export function rejectIfInvalidCSRFResponse(response: AxiosResponse) {
    if (isInvalidCSRFResponse(response)) {
        // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors -- Legacy code: do not use as an example.
        return Promise.reject(response);
    }

    return response;
}
